export default {
    needWork: 'Needs Work',
    goodStart: 'Good Start',
    excellentJob: 'Excellent',
}